import { render, staticRenderFns } from "./PoliciesTable.vue?vue&type=template&id=15f6896e&"
import script from "./PoliciesTable.vue?vue&type=script&lang=js&"
export * from "./PoliciesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports